import React from 'react';
import { Row, Column, Justify } from '@uds/grid';

import getClassNames from './Reviews.stylesheet';
import Review, { ReviewProps } from './Review';

interface OuterProps {
  reviews: Array<ReviewProps>;
}

declare const i: number;
declare const review: ReviewProps;

export const AdvocateTrustpilotReviews = ({ reviews }: OuterProps) => {
  const classNames = getClassNames();
  return (
    <Row justify={Justify.CENTER}>
      <For each="review" of={reviews} index="i">
        <Column key={i} xs={12} sm={6} md={4} lg={3}>
          <div className={classNames.review}>
            <Review {...review} />
          </div>
        </Column>
      </For>
    </Row>
  );
};

AdvocateTrustpilotReviews.displayName = 'AdvocateTrustpilotReviews';

export default AdvocateTrustpilotReviews;
